export default {
    consulta: {id: "consulta", showForm: false, acao: "Cadastro", done: "Cadastrado", do: "Cadastrar" },
    inclusao: {id: "inclusao", showForm: true, acao: "Inclusão", done: "Incluido", do: "Incluir" },
    alteracao: {id: "alteracao", showForm: true, acao: "Alteração", done: "Alterado", do: "Alterar" },
    retificacao: {id: "retificacao", showForm: true, acao: "Retificação", done: "Retificado", do: "Retificar" },
    exclusao: {id: "exclusao", showForm: false, acao: "Exclusão", done: "Excluido", do: "Excluir" },
    visualizar:{id: "visualizar", showForm: true, acao: "Visualização", done:"Visualizado", do: "Visualizar"},
};